import React, { useEffect, useState } from 'react'
import { api } from '../../lib/api'
import type { ContactRequest } from '../../lib/types'

export default function AdminContactRequests() {
  const [requests, setRequests] = useState<ContactRequest[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api('/admin/contact-requests').then((rows) => { setRequests(rows); setLoading(false) })
  }, [])

  if (loading) return <div className="page-loading">Loading inbound requests…</div>

  return (
    <div>
      <div className="page-head">
        <h1>Inbound requests</h1>
        <div className="ph-sub">Demo/contact form submissions from the public site.</div>
      </div>

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr><th>Name</th><th>Email</th><th>Message</th><th>Source</th><th>Received</th><th>Status</th></tr>
          </thead>
          <tbody>
            {requests.map((r) => (
              <tr key={r.id}>
                <td>{r.practice_or_organization_name}</td>
                <td className="muted">{r.email}</td>
                <td>{r.message}</td>
                <td className="muted">{r.source_page || '—'}</td>
                <td className="muted">{new Date(r.created_at).toLocaleString()}</td>
                <td><span className="badge badge-blue">{r.status}</span></td>
              </tr>
            ))}
            {requests.length === 0 && <tr><td colSpan={6} className="muted">No inbound requests yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  )
}
